// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect  } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';

import { useTranslation } from "react-i18next";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { display } from '@mui/system';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdateExpiredDateModal = ({
    updateExpiredDateModalOpen,
    setUpdateExpiredDateModalOpen,
    row,
    fetchPresetTasklist
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [expiredDate, setExpiredDate] = useState(null);
    
    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateExpiredDate = async () => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/PresetCustomerTasklist/ExpiredDate',
                {
                    id: row.id,
                    expiredDate: expiredDate != null ? expiredDate.format('YYYY-MM-DD') : null
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新截至日期');
                fetchPresetTasklist();
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    return (
        <>
            <Modal
                open={updateExpiredDateModalOpen}
                onClose={() => setUpdateExpiredDateModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("customer.updateExpiredDate")}
                        </Typography>
                        <Cancel onClick={() => setUpdateExpiredDateModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '25px',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            marginTop: '30px'
                        }}
                    >
                        {t("customer.confirmUpdateExpiredDate")} ?
                    </Typography>
                    <Box style={{alignItems: 'center', textAlign: 'center', marginTop: '20px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{fontSize: '14px'}}>
                            <DatePicker
                                value={expiredDate}
                                label={t("customer.expiredDate")}
                                slotProps={{
                                    textField: {
                                        error: false,
                                        size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                        sx: {
                                        '& .MuiInputBase-root': {
                                            fontSize: '13px',      // font size of the input
                                            padding: '4px 8px',    // optional: reduce input padding
                                            minHeight: '36px',     // optional: control input height
                                        },
                                        '& .MuiInputBase-input': {
                                            fontSize: '13px',      // font size inside input
                                            padding: '8.5px 14px', // adjust input padding if needed
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '13px',      // label font size
                                        },
                                        },
                                    }
                                }}
                                onChange={(newValue) => setExpiredDate(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box style={{alignItems: 'center', textAlign: 'center'}}>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '30px'
                            }}
                            onClick={submitUpdateExpiredDate}
                            disabled={updateButtonDisabled}
                        >
                            {t("customer.confirm")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: 'grey',
                                marginTop: '30px',
                                marginLeft: '30px'
                            }}
                            onClick={() => setUpdateExpiredDateModalOpen(false)}
                            disabled={updateButtonDisabled}
                        >
                            {t("customer.cancel")}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default UpdateExpiredDateModal;